import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Page {
  slug: string;
  legacySlug: string;
  logoUrl: string;
  category: string; 
  employees: string; 
  pricingPageUrl: string;
  description?: string;
  screenshotUrl: string;
  screenshotUrlVersion: string | null;
}

interface PagesState {
  pages: Page[];
  loading: boolean;
  error: string | null;
  uniqueCategories: string[];
  uniqueEmployees: string[];
}

const initialState: PagesState = {
  pages: [],
  loading: false,
  error: null,
  uniqueCategories: [],
  uniqueEmployees: [],
};

const supaPagesSlice = createSlice({
  name: 'supaPages',
  initialState,
  reducers: {
    setPages: (state, action: PayloadAction<Page[]>) => {
      state.pages = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setUniqueCategories: (state, action: PayloadAction<string[]>) => {
      state.uniqueCategories = action.payload;
    },
    setUniqueEmployees: (state, action: PayloadAction<string[]>) => {
      state.uniqueEmployees = action.payload;
    },
  },
});

export const {
  setPages,
  setLoading,
  setError,
  setUniqueCategories,
  setUniqueEmployees,
} = supaPagesSlice.actions;

export default supaPagesSlice.reducer;